import { createAction } from "../../utils";

import {
  SET_TLDS_WITH_SEPARATE_PAGE_TERMS,
  SET_TLDS_WITH_SPECIAL_REGISTRY_TERMS,
} from "../../constants";
import {
  getTLDsFromCart,
  getCustomerCountryFromSession,
  getCitizenshipCountryFromSession,
} from "../../selectors";

const setSeparatePageTerms = createAction(SET_TLDS_WITH_SEPARATE_PAGE_TERMS);
const setSpecialRegistryTerms = createAction(
  SET_TLDS_WITH_SPECIAL_REGISTRY_TERMS,
);

export const getTerms = () => {
  return async (dispatch, getState, { api }) => {
    const listOfTlds = getTLDsFromCart(getState());
    const countryFromForm = getCustomerCountryFromSession(getState());
    const citizenshipCountry = getCitizenshipCountryFromSession(getState());
    const processedTlds = listOfTlds.map((tld) => `tlds=${tld}`).join("&");

    const country = citizenshipCountry || countryFromForm;

    return api.getTerms(processedTlds, country).then(
      (data) => {
        const termsCombined = data.result.termsCombined.filter(
          (term) => term !== "SEPARATE_PAGE_TERMS",
        );
        const tldTerms = data.result.tldTerms;

        const tldsWithSeparateTermsPage = tldTerms
          .filter((tld) => tld.terms.includes("SEPARATE_PAGE_TERMS"))
          .map(({ tld }) => tld);

        dispatch(setSeparatePageTerms(tldsWithSeparateTermsPage));

        const tldsWithSpecialRegistryTerms = tldTerms
          .filter((tld) => tld.terms.some((term) => term.includes("SPECIAL_")))
          .map(({ tld }) => tld);

        dispatch(setSpecialRegistryTerms(tldsWithSpecialRegistryTerms));

        return {
          wasSuccessful: true,
          termsCombined: termsCombined.length > 0 ? termsCombined : null,
          tldsWithSeparateTermsPage:
            tldsWithSeparateTermsPage.length > 0
              ? tldsWithSeparateTermsPage
              : null,
          tldsWithSpecialRegistryTerms:
            tldsWithSpecialRegistryTerms.length > 0
              ? tldsWithSpecialRegistryTerms
              : null,
          eID: data.result.eid,
        };
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
